/**
 * mcycle homepage header bottombar module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/8
 */
import './bottomBar.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class BottomBar extends Component {
  render() {
    const { bannerList, pageInfo } = this.props;
    const fontColor = pageInfo.frontConfig.textRgb ? {color: pageInfo.frontConfig.textRgb} : {};

    return (
      <div className="mcycle-home-bottom-bar">
        <ul className="mcycle-home-bottom-list clearfix">
          {
            bannerList.map((item, index) => (
              <li className="mcycle-home-bottom-select" key={ index }>
                { item.icon }
                <span className="mcycle-home-header-font-color" style={ fontColor }>{ item.text }</span>
              </li>
            ))
          }
        </ul>
      </div>
    )
  }
}

export default connect(
  state => ({
    pageInfo: state.home.pageInfo
  })
)(BottomBar)


// WEBPACK FOOTER //
// ./src/components/home/header/bottomBar/bottomBar.js